import React, { useState, useRef } from "react";
import { useModal } from "../../../contexts/modalContext/modalContext.js";
import { useContent } from "../../../contexts/contentContext/contentContext.js";
import { useToasts } from "react-toast-notifications";
import Button from "../../Elements/Button/Button.js";
import LoaderContainer from "../LoaderContainer/LoaderContainer.js";
import EmbedBackgroundSelector from "./EmbedBackgroundSelector.js";
import { SizeMe } from "react-sizeme";
import apiRequest from "../../../utils/ApiRequest/apiRequest.js";
import "./EmbedBackgroundUploader.scss";
import { defaultBackgrounds } from "../JUMBOform/ExternalJsonsList/JsonLists.js";
import { jumbomailImagesSizeLimit } from "utils/jumbomailSettings.js";
import config from "config";
import ToastHtmlComponent from "../ToastHtmlComponent/ToastHtmlComponent.js";

const fileReader = new FileReader();

const EmbedBackgroundUploader = ({
  imagesList,
  setImagesList,
  backgroundImage,
  setBackgroundImage,
  imageOrder,
  setImageOrderToReplace,
  backgroundName = null,
  pcImage = null,
  errorsInput = null,
  setErrorsInput = null,
  needReplace,
}) => {
  //canvas logic
  const { closeModal } = useModal();
  const [loading, setLoading] = useState(false);
  const { getTextByKey } = useContent();
  const { addToast } = useToasts();
  const [image, setImage] = useState(backgroundImage ? backgroundImage : null);
  const [isImageFromPC, setIsImageFromPC] = useState(pcImage ? pcImage : false);
  const [error, setError] = useState(errorsInput ? errorsInput : null);
  const inputRef = useRef();
  const canvasRef = useRef();
  const uploadedFileName = useRef();

  fileReader.onload = function (event) {
    var image = new Image();
    image.onload = function () {
      const canvas = document.createElement("canvas");
      const context = canvas.getContext("2d");
      const ratio = image.width > 2500 ? image.width / 2500 : 1;
      canvas.width = image.width / ratio;
      canvas.height = image.height / ratio;
      context.drawImage(
        image,
        0,
        0,
        image.width,
        image.height,
        0,
        0,
        canvas.width,
        canvas.height
      );
      setImage(canvas.toDataURL());
    };
    image.src = event.target.result;
  };

  //function will be fired after selecting photo from pc
  const handleNewImage = (e) => {
    if (e.target.files[0]) {
      setError(null);
      if (setErrorsInput) {
        setErrorsInput(null);
      }
      const allowedExtensions = ["jpg", "jpeg", "png", "gif", "bmp", "webp"];
      const fileExtension = e.target.files[0].name
        .split(".")
        .pop()
        .toLowerCase();
      const fileSize = e.target.files[0].size;
      const validSize = jumbomailImagesSizeLimit["embedPageBackground"];
      const allowedSize = validSize >= fileSize;
      const isAllowedExtension = allowedExtensions.includes(fileExtension);
      if (isAllowedExtension && allowedSize) {
        setIsImageFromPC(true);
        fileReader.readAsDataURL(e.target.files[0]);
        uploadedFileName.current = e.target.files[0].name.replaceAll("&", "-");
      } else {
        setError(
          !isAllowedExtension
            ? getTextByKey("file-type-not-supported")
            : getTextByKey("embed-logo-validation-size-text")
        );
      }
    }
  };

  //clicking to "upload" button
  const handleClick = () => {
    inputRef.current.click();
  };

  // checking a size of selected image to
  const [imageSizes, setImageSizes] = useState({
    valid: true,
    width: "",
    height: "",
  });

  //saving image to s3 storage
  const handleSubmit = async () => {
    if (!error) {
      if (isImageFromPC) {
        setBackgroundImage(image);
        setLoading(true);
        const canvas = isImageFromPC
          ? canvasRef.current.getImage().toDataURL()
          : canvasRef.current.props.image;

        var proxyUrl =
          canvas.indexOf("data:image/png;base64,") > -1 || isImageFromPC
            ? ""
            : "https://proxy.jumbomail.me/";

        const blobResponse = await fetch(proxyUrl + canvas)
          .then((res) => res.blob())
          .then((blob) => {
            return blob;
          });

        const name = backgroundName
          ? backgroundName
          : image && image.name
          ? image.name.replaceAll("&", "-")
          : uploadedFileName.current;

        uploadBackgroundImage({
          image: blobResponse,
          fileName: name,
          fileId: 0,
        });
      }

      closeModal();
      setLoading(false);
    }
  };
  const cancelImage = () => {
    setError(null);
    if (setErrorsInput) {
      setErrorsInput(null);
    }
    closeModal();
    setTimeout(() => {
      setImage(null);
      setBackgroundImage(null);
    }, 1000);
  };

  const uploadBackgroundImage = async ({ image, fileName, fileId }) => {
    const response = await apiRequest(
      "UserTemplates",
      `CreateOrUpdateBackgroundEmbedReact?&encryptedMailId=0&fileName=${fileName}&fileId=${fileId}&imageOrder=${imageOrder}`,
      image,
      "POST",
      null,
      null,
      null,
      true
    );
    if (response.status === "success") {
      if (response.data) {
        if (imageOrder > 0) {
          setImageOrderToReplace(imageOrder);
        } else {
          // if (needReplace) {
          // }
          // setImageOrderToReplace(1);
        }
        //setBackgroundImage(null);
      }
    } else {
      if (imagesList) {
        let tempList = imagesList;
        setImagesList(tempList);
      }
      let errText = getTextByKey("api-error");
      errText = errText.replace("#ERRORNUM#", 929345);
      errText = errText.replace("#SYSMAIL#", "contact-us");
      errText = errText.replace("#SYSMAIL#", config.supportmail);
      errText = errText.replace("#SYSMAIL#", "contact-us");
      addToast(<ToastHtmlComponent htmlStr={errText} />, {
        appearance: "error",
      });
    }
  };

  return (
    <div className="embed-background-container">
      <input
        accept="image/*"
        className="click-to-action-upload-input"
        name="newImage"
        type="file"
        onChange={handleNewImage}
        ref={inputRef}
      ></input>
      <div className="embed-background-title title">
        <h1>{getTextByKey("background-image-title-personal-page")}</h1>
        <div className="embed-background-sub-title">
          <span>{getTextByKey("embed-background-limit-size")}</span>
        </div>
      </div>
      <div className="embed-background-content">
        <SizeMe>
          {({ size }) => (
            <div className="embed-background-content-start">
              <EmbedBackgroundSelector
                backgroundImage={defaultBackgrounds[0]}
                image={image}
                size={size}
                handleClick={handleClick}
                handleNewImage={handleNewImage}
                inputRef={inputRef}
                ref={canvasRef}
                setImageSizes={setImageSizes}
                imageSizes={imageSizes}
                error={error}
              />
              <div className={`embed-background-footer`}>
                {imageSizes.valid ? (
                  <div className="embed-background-submit-button">
                    <LoaderContainer isLoading={loading}>
                      <Button
                        className={image ? null : "hidden"}
                        onClick={handleSubmit}
                      >
                        {getTextByKey("save")}
                      </Button>
                      <Button
                        blank
                        className={image ? null : "hidden"}
                        onClick={cancelImage}
                      >
                        {getTextByKey("cancel")}
                      </Button>
                    </LoaderContainer>
                  </div>
                ) : (
                  <Button
                    blank
                    className={image ? null : "hidden"}
                    onClick={cancelImage}
                  >
                    {getTextByKey("cancel")}
                  </Button>
                )}
              </div>
            </div>
          )}
        </SizeMe>
      </div>
    </div>
  );
};

export default EmbedBackgroundUploader;
